import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";
import PreliminaryDetailsTab from "./Tabs/PreliminaryDetailsTab";
import OwnersTab from "./Tabs/OwnerDetailsTab";
import PropertiesTab from "./Tabs/PropertiesTab";
import BuildingsTab from "./Tabs/BuildingsTab";
import FeaturesTab from "./Tabs/FeaturesTab";
import AttachmentsTab from "./Tabs/AttachmentsTab";

const ValuationDetailsModal = ({ isOpen, toggle, valuation }) => {
    const [activeTab, setActiveTab] = useState("preliminary");

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size="xl"
            backdrop="static"   // prevent closing on outside click
            keyboard={false}    // prevent closing on ESC key
        >
            <ModalHeader toggle={toggle}>
                Valuation Details — {valuation?.valuation_ref || ""}
            </ModalHeader>
            <ModalBody>
                {/* Tabs Header */}
                <ul className="nav nav-pills nav-justified mb-3">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "preliminary" ? "active" : ""}`}
                            onClick={() => setActiveTab("preliminary")}
                        >
                            Preliminary Details
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "owners" ? "active" : ""}`}
                            onClick={() => setActiveTab("owners")}
                        >
                            Owners
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "property" ? "active" : ""}`}
                            onClick={() => setActiveTab("property")}
                        >
                            Property
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "buildings" ? "active" : ""}`}
                            onClick={() => setActiveTab("buildings")}
                        >
                            Buildings
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "features" ? "active" : ""}`}
                            onClick={() => setActiveTab("features")}
                        >
                            Features
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "attachments" ? "active" : ""}`}
                            onClick={() => setActiveTab("attachments")}
                        >
                            Attachments
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "review" ? "active" : ""}`}
                            onClick={() => setActiveTab("review")}
                        >
                            Review & Approval
                        </button>
                    </li>
                </ul>

                {/* Tabs Content */}
                <div className="tab-content p-3">
                    {activeTab === "preliminary" && (
                        <PreliminaryDetailsTab valuation={valuation} />
                    )}
                    {activeTab === "owners" && (
                        <OwnersTab valuationId={valuation?.id} />
                    )}
                    {activeTab === "property" && (
                        <PropertiesTab valuationId={valuation?.id} />
                    )}
                    {activeTab === "buildings" && (
                        <BuildingsTab valuationId={valuation?.id} />
                    )}
                    {activeTab === "features" && (
                        <FeaturesTab valuationId={valuation?.id} />
                    )}
                    {activeTab === "attachments" && (
                        <AttachmentsTab valuationId={valuation?.id} />
                    )}
                    {/* {activeTab === "review" && <ReviewTab valuationId={valuation?.id} />} */}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ValuationDetailsModal;
